import Vue from 'vue';

import Klienti from './components/Klienti.vue'
// import SluzbaDetail from './components/SluzbaDetail.vue'

console.log("klienti.js");

new Vue({
  el: '#klientiApp',
  components: {
    'klienti': Klienti,
    // 'sluzba-detail': SluzbaDetail,
  }
});